export function animationOnScroll() {
    const $window = $(window);
    const $lineBlock = $('.info-item-media');
    let $items = $(".has-animation");
    let $lineDrawingElement;
    let $lineDrawingElementPath;
    let animation;
    let animationData;
    let animationArray = [];
    // console.log('$lineBlock  ', $lineBlock );
    //drawing svg
    if( $lineBlock ){
        $lineBlock.each(function (index, el) {
            $lineDrawingElement = this.querySelector(".info-item-media");
            $lineDrawingElementPath = this.dataset.path;
            animationData = {
                container: this,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: $lineDrawingElementPath
            };
            animation = bodymovin.loadAnimation(animationData);
            animationArray.push(animation);
        });
        // console.log('animationArray ', animationArray);
    }

    $window.on("scroll load", function () {
        $items.each(function (i, it) {
            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.75 && !$(it).hasClass("animate")) {
                $(it).addClass("animate");
                if(  $(this).hasClass("info-item") ){
                    // console.log('has class');
                    let curIndex = $(this).index();
                    // console.log('curIndex ',curIndex);
                    animationArray[curIndex].play();
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animationOnScroll.js